import { useRef, useState } from 'react';
import { Carousel, type CarouselRef, type CarouselSettings } from 'yoc-ui-library';

import ArrowButton from '@components/Button/ArrowButton';

import type { IGalleryProps } from './types';

import style from './styles.module.scss';

const Gallery = ({ slides }: IGalleryProps) => {
  const carouselRef = useRef<CarouselRef>(null);
  const [activeSlideNumber, setActiveSlideNumber] = useState(0);

  if (!slides || slides.length === 0) {
    return null;
  }

  const settings: CarouselSettings = {
    dots: false,
    arrows: false,
    infinite: false,
    centerPadding: '24%',
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: false,
    beforeChange: (_currentSlide: number, nextSlide: number) => {
      setActiveSlideNumber(nextSlide);
    },
  };

  return (
    <div className={style['gallery-container']}>
      <div className={style['carousel-viewport']}>
        <Carousel
          {...settings}
          className={style.slider}
          ref={carouselRef}
        >
          {slides.map((item, index) => {
            return (
              <div
                key={index}
                className={style['slide-wrapper']}
              >
                {item}
              </div>
            );
          })}
        </Carousel>
      </div>

      <div className={style['gallery-nav']}>
        <ArrowButton
          className={style['arrow-button']}
          direction="left"
          color="#111"
          disabled={activeSlideNumber === 0}
          onClick={() => {
            carouselRef.current?.prev();
          }}
        />
        <ul className={style.dots}>
          {slides.map((_, index) => {
            return (
              <li
                key={index}
                className={index === activeSlideNumber ? style['slick-active'] : ''}
              >
                <button
                  onClick={() => {
                    carouselRef.current?.goTo(index);
                  }}
                />
              </li>
            );
          })}
        </ul>
        <ArrowButton
          className={style['arrow-button']}
          direction="right"
          color="#111"
          disabled={activeSlideNumber === slides.length - 1}
          onClick={() => {
            carouselRef.current?.next();
          }}
        />
      </div>
    </div>
  );
};

export default Gallery;
